'use client';

import { usePathname } from 'next/navigation';
import { Box, Divider } from '@wishket/design-system';

import { MAIN_NAV_ITEMS } from './AppBar.constants';
import { SubNavigationLinkItem } from './parts';

import { PATH } from '@/shared/constants';

interface Category {
  name: string;
  flag: string;
  ogTitle: string;
  ogDescription: string;
  ogImage: string;
}

interface SubNavigationBarProps {
  categoryList: Category[];
}

const SubNavigationBar = ({ categoryList }: SubNavigationBarProps) => {
  const pathname = usePathname();

  return (
    <nav
      data-testid="sub-nav-root"
      className="box-border flex flex-nowrap items-center gap-4 overflow-x-auto whitespace-nowrap px-5 grid-in-content scrollbar-hide desktop:px-0"
    >
      <Box
        className="flex items-center gap-5 desktop:hidden"
        data-testid="sub-nav-main"
      >
        {MAIN_NAV_ITEMS.map((item) => (
          <SubNavigationLinkItem
            key={item.href}
            href={item.href}
            isNew={item.isNew}
            hasAiLabel={item.hasAiLabel}
            isActive={pathname === `${item.href}/`}
            isMain
          >
            {item.label}
          </SubNavigationLinkItem>
        ))}
        <Divider isVertical className="my-3 h-4 flex-shrink-0" />
      </Box>
      <Box
        data-testid="sub-nav-category"
        className="flex items-center gap-5 desktop:gap-8"
      >
        {categoryList.map((category) => (
          <SubNavigationLinkItem
            key={category.flag}
            href={`${PATH.LIST}/${category.flag}`}
            isActive={pathname === `${PATH.LIST}/${category.flag}/`}
          >
            {category.name}
          </SubNavigationLinkItem>
        ))}
      </Box>
    </nav>
  );
};

export default SubNavigationBar;
